import React, { useRef } from "react";

import Box from "@mui/material/Box";

import FirmographicQuestionsForm from "./FirmographicQuestionsForm";

const FirmographicQuestions = ({ respondentId, firmographic, formActions, onSubmit }) => {
    const formikRef = useRef(null);

    return (
        <Box sx={{ height: '80vh', display: 'flex', flexDirection: 'column' }}>
            <FirmographicQuestionsForm
                respondentId={respondentId}
                firmographic={firmographic}
                formActions={formActions}
                onSubmit={onSubmit}
                ref={formikRef}
            />
        </Box>
    )
}

export default FirmographicQuestions